/* eslint-disable max-len */
export const REPORT_SECTION_ALIASES = {
  // Leilão e subitens
  leilao: ['auction', 'auctionAdditional', 'auctionChecklist', 'auctionScore', 'auctionPercentage', 'auctionSpecialInspection'],
  leiloes: ['auction', 'auctionAdditional', 'auctionChecklist', 'auctionScore', 'auctionPercentage', 'auctionSpecialInspection'],
  auction: ['auction', 'auctionAdditional', 'auctionChecklist', 'auctionScore', 'auctionPercentage', 'auctionSpecialInspection'],

  // Débitos e multas
  debitos: ['debts', 'renainf'],
  multas: ['debts', 'renainf'],
  debts: ['debts', 'renainf'],
  renainf: ['renainf'],

  // Proprietários
  proprietarios: ['owners'],
  proprietario: ['owners'],
  donos: ['owners'],
  owners: ['owners'],

  // Sinistro
  sinistro: ['casualty'],
  sinistros: ['casualty'],
  casualty: ['casualty'],

  // Quadro de avisos / Resumo
  quadro: ['board', 'boardNational', 'boardState', 'boardChassis', 'boardEngine'],
  avisos: ['board', 'boardNational', 'boardState', 'boardChassis', 'boardEngine'],
  resumo: ['board', 'boardNational', 'boardState', 'boardChassis', 'boardEngine'],
  board: ['board', 'boardNational', 'boardState', 'boardChassis', 'boardEngine'],

  // Preço / FIPE / Precificador
  fipe: ['pricer'],
  preco: ['pricer'],
  precificador: ['pricer'],
  pricer: ['pricer'],

  // Gravame / Alienação
  gravame: ['lien'],
  alienacao: ['lien'],
  lien: ['lien'],

  // Renajud / Bloqueio Judicial
  renajud: ['renajud'],
  judicial: ['renajud'],

  // Roubo e Furto
  roubo: ['robbery'],
  furto: ['robbery'],
  roubofurto: ['robbery'],
  robbery: ['robbery'],

  // Recall
  recall: ['recall'],

  // KM / Quilometragem
  km: ['km'],
  quilometragem: ['km'],

  // Fotos e Anúncios
  fotos: ['photos', 'ads'],
  anuncios: ['ads'],
  ads: ['ads'],
  photos: ['photos'],

  // Diagnóstico / Fotos e Conclusão
  diagnostico: ['diagnosis'],
  conclusao: ['diagnosis'],
  diagnosis: ['diagnosis'],

  // Dados Cadastrais / Registro
  cadastro: ['register'],
  dados: ['register'],
  cadastrais: ['register'],
  register: ['register'],

  // Decodificador de Chassi
  decodificador: ['decoder'],
  chassi: ['decoder'],
  decoder: ['decoder'],

  // Ficha Técnica
  ficha: ['technicalSheet'],
  tecnica: ['technicalSheet'],
  fichatecnica: ['technicalSheet'],
  technicalsheet: ['technicalSheet'],

  // Acessórios
  acessorios: ['accessories'],
  accessories: ['accessories'],

  // Peças
  pecas: ['parts'],
  parts: ['parts'],

  // Revisões
  revisoes: ['revision'],
  revision: ['revision'],

  // CSV
  csv: ['csv'],

  // Análise de Risco
  risco: ['riskAnalysis'],
  analisederisco: ['riskAnalysis'],
  riskanalysis: ['riskAnalysis'],

  // Base Estadual
  estadual: ['state'],
  baseestadual: ['state'],
  state: ['state'],

  // Base Nacional
  nacional: ['national'],
  basenacional: ['national'],
  national: ['national'],

  // Restrições
  restricoes: ['restrictions'],
  restrictions: ['restrictions'],

  // Radar
  radar: ['radar'],

  // Promoção / Banners
  promocao: ['promote'],
  promote: ['promote'],

  // Workflows / Opcionais extras
  workflows: ['workflows'],
  opcionais: ['workflows'],

  // Veículos registrados para o documento
  documento: ['byDocument'],
  veiculosdocumento: ['byDocument'],
  bydocument: ['byDocument'],
};

// Seções detalhadas analíticas que são ocultadas no "Modo Laudo Resumido"
export const DETAILED_REPORT_SECTIONS = [
  'register', 'decoder', 'national', 'state', 'technicalSheet',
  'accessories', 'owners', 'robbery', 'auction', 'auctionAdditional',
  'auctionChecklist', 'auctionScore', 'auctionPercentage', 'auctionSpecialInspection',
  'casualty', 'csv', 'riskAnalysis', 'recall', 'km', 'renainf', 'lien',
  'renajud', 'radar', 'ads', 'photos', 'revision', 'parts', 'debts',
  'diagnosis', 'byDocument', 'workflows', 'promote'
];

export const ALL_REPORT_SECTIONS = [
  'board', 'boardNational', 'boardState', 'boardChassis', 'boardEngine',
  ...DETAILED_REPORT_SECTIONS
];

export function resolveHideKeys(query = {}) {
  const hideSet = new Set();
  if (!query || typeof query !== 'object') {
    return [];
  }

  const parseTokens = (param) => {
    if (!param) return [];
    if (Array.isArray(param)) {
      return param.flatMap((p) => p.toString().split(',')).map((s) => s.trim().toLowerCase()).filter(Boolean);
    }
    return param.toString().split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
  };

  // 1. Ocultar / Hide (Blacklist)
  const hideParam = query.hide || query.ocultar || query.esconder;
  if (hideParam) {
    const tokens = parseTokens(hideParam);
    tokens.forEach((token) => {
      if (token === 'detalhes' || token === 'details') {
        DETAILED_REPORT_SECTIONS.forEach((k) => hideSet.add(k));
      } else if (REPORT_SECTION_ALIASES[token]) {
        REPORT_SECTION_ALIASES[token].forEach((k) => hideSet.add(k));
      } else {
        hideSet.add(token);
      }
    });
  }

  // 2. Modo Resumo / Sintético
  const isSummaryMode =
    query.hideDetails === 'true' ||
    query.hideDetails === '1' ||
    query.detalhes === 'false' ||
    query.detalhes === '0' ||
    query.resumo === 'true' ||
    query.resumo === '1' ||
    query.mode === 'summary';

  if (isSummaryMode) {
    DETAILED_REPORT_SECTIONS.forEach((k) => hideSet.add(k));
  }

  // 3. Exibir somente / Whitelist (only, somente, show, apenas)
  const onlyParam = query.only || query.somente || query.show || query.apenas;
  if (onlyParam) {
    const allowedTokens = parseTokens(onlyParam);
    const allowedKeys = new Set();
    allowedTokens.forEach((token) => {
      if (token === 'detalhes' || token === 'details') {
        DETAILED_REPORT_SECTIONS.forEach((k) => allowedKeys.add(k));
      } else if (REPORT_SECTION_ALIASES[token]) {
        REPORT_SECTION_ALIASES[token].forEach((k) => allowedKeys.add(k));
      } else {
        allowedKeys.add(token);
      }
    });

    ALL_REPORT_SECTIONS.forEach((section) => {
      if (!allowedKeys.has(section)) {
        hideSet.add(section);
      }
    });
  }

  return Array.from(hideSet);
}

export function sanitizeReportData(item, hideKeys = []) {
  if (!item || !item.vehicle || !Array.isArray(hideKeys) || hideKeys.length === 0) {
    return item;
  }
  const hideSet = new Set(hideKeys);
  const { vehicle } = item;

  if (hideSet.has('auction')) {
    delete vehicle.leilao;
    delete vehicle.leilao4Corp;
  }
  if (hideSet.has('debts')) {
    delete vehicle.debitos;
    delete vehicle.debitosMultas;
  }
  if (hideSet.has('renainf')) {
    delete vehicle.multasRenainf;
    delete vehicle.multas;
  }
  if (hideSet.has('owners')) {
    delete vehicle.proprietarios;
    delete vehicle.historicoProprietarios;
  }
  if (hideSet.has('lien')) {
    delete vehicle.gravame;
  }
  if (hideSet.has('renajud')) {
    delete vehicle.renajuds;
  }
  if (hideSet.has('robbery')) {
    delete vehicle.rouboFurto;
  }
  if (hideSet.has('casualty')) {
    delete vehicle.indicioSinistro;
  }
  if (hideSet.has('recall')) {
    delete vehicle.recall;
  }
  if (hideSet.has('km')) {
    delete vehicle.historicoKm;
  }
  if (hideSet.has('radar')) {
    delete vehicle.radar;
  }
  if (hideSet.has('csv')) {
    delete vehicle.csv;
  }
  if (hideSet.has('riskAnalysis')) {
    delete vehicle.analiseRisco;
  }
  if (hideSet.has('ads') || hideSet.has('photos')) {
    delete vehicle.anuncio;
  }
  if (hideSet.has('diagnosis')) {
    delete item.photos;
    delete item.finish;
  }
  if (hideSet.has('technicalSheet')) {
    delete vehicle.fichaTecnica;
  }
  if (hideSet.has('accessories')) {
    delete vehicle.equipamentos;
  }
  if (hideSet.has('parts')) {
    delete vehicle.pecas;
  }
  if (hideSet.has('revision')) {
    delete vehicle.revisao;
  }
  if (hideSet.has('byDocument')) {
    delete vehicle.veiculos;
  }

  return item;
}

export function applyUrlFilters(item, query = {}) {
  if (!item) return item;
  const hideKeys = resolveHideKeys(query);
  if (hideKeys.length === 0) return item;

  if (!item.config) {
    item.config = { hide: [] };
  } else if (!Array.isArray(item.config.hide)) {
    item.config.hide = [];
  }

  const merged = new Set([...item.config.hide, ...hideKeys]);
  item.config.hide = Array.from(merged);

  sanitizeReportData(item, hideKeys);
  return item;
}
